import { icons } from './icons';
import { images } from './images';

export * from './svg';

export const assets = {
  images,
  icons,
};
